import styled from 'styled-components';
import { rem } from 'polished';
import { VehiclePriceDetailsBlockStyled } from '../VehiclePriceDetailsBlockStyled';
export const VehiclePriceDetailsBlockStyledAP = styled(VehiclePriceDetailsBlockStyled)`
    .row {
        .rowTitle {
            font-size: ${rem('12px')};
        }

        .info,
        .infoOptions {
            font-size: ${rem('12px')};
            line-height: 1.33;
        }
    }
`;
